import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {
  CriticalIllness,
  matchCriticalIllnessByType,
} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/CriticalIllness';
import * as G from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/GroupCriticalIllness';
import * as NY from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/NewYorkCriticalIllness';
import * as O from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/OrdinaryCriticalIllness';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import RiderInformationBase from 'ApplicationEntry/models/ProductsRiders/RiderInformation';
import {Async, Loading} from 'Core/models/Async';
import {NonEmptyString} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum CriticalIllnessActionType {
  CHANGE_PRODUCT_TYPE = 'criticalIllness/CHANGE_PRODUCT_TYPE',
  CHANGE_PLAN_TYPE = 'criticalIllness/CHANGE_PLAN_TYPE',
  CHANGE_BENEFIT_AMOUNT = 'criticalIllness/CHANGE_BENEFIT_AMOUNT',
  CHANGE_PREMIUM = 'criticalIllness/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'criticalIllness/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'criticalIllness/CHANGE_CWA',
  CHANGE_INSURED_SC = 'criticalIllness/CHANGE_INSURED_SC',
  CHANGE_SPOUSE_SC = 'criticalIllness/CHANGE_SPOUSE_SC',
  CHANGE_SECTION125 = 'criticalIllness/CHANGE_SECTION125',
  CHANGE_REPLACEMENT = 'criticalIllness/CHANGE_REPLACEMENT',
  CHANGE_POLICY_NUMBER = 'criticalIllness/CHANGE_POLICY_NUMBER',
  CHANGE_SITUS_STATE = 'criticalIllness/CHANGE_SITUS_STATE',
  CHANGE_CANCER = 'criticalIllness/CHANGE_CANCER',
  CHANGE_SKIN_CANCER = 'criticalIllness/CHANGE_SKIN_CANCER',
  CHANGE_CARDIOPULMONARY_ENHANCEMENT = 'criticalIllness/CHANGE_CARDIOPULMONARY_ENHANCEMENT',
  CHANGE_LIFESTYLE_ENHANCEMENT = 'criticalIllness/CHANGE_LIFESTYLE_ENHANCEMENT',
  CHANGE_SECOND_EVALUATION_TRANSPORTATION = 'criticalIllness/CHANGE_SECOND_EVALUATION_TRANSPORTATION',
  CHANGE_SPECIFIED_DISEASE_ENHANCEMENT = 'criticalIllness/CHANGE_SPECIFIED_DISEASE_ENHANCEMENT',
  CHANGE_SPECIFIED_CHRONIC_CI = 'criticalIllness/CHANGE_SPECIFIED_CHRONIC_CI',
  CHANGE_SPECIFIED_CHRONIC_CI_INJURY = 'criticalIllness/CHANGE_SPECIFIED_CHRONIC_CI_INJURY',
  CHANGE_RECURRENCE = 'criticalIllness/CHANGE_RECURRENCE',
  CHANGE_CRITICAL_ILLNESS_ENHANCEMENT = 'criticalIllness/CHANGE_CRITICAL_ILLNESS_ENHANCEMENT',
  CHANGE_WELLNESS_UNITS = 'criticalIllness/CHANGE_WELLNESS_UNITS',
  CHANGE_FIXED_WELLNESS = 'criticalIllness/CHANGE_FIXED_WELLNESS',
  CHANGE_VARIABLE_WELLNESS = 'criticalIllness/CHANGE_VARIABLE_WELLNESS',
  CHANGE_WELLNESS_PREVENTIVE_CARE = 'criticalIllness/CHANGE_WELLNESS_PREVENTIVE_CARE',
  CHANGE_CI_BENEFIT = 'criticalIllness/CHANGE_CI_BENEFIT',
  CHANGE_CI_OPTION_II = 'criticalIllness/CHANGE_CI_OPTION_II',
  CHANGE_SECOND_EVENT_CI = 'criticalIllness/CHANGE_SECOND_EVENT_CI',
  CHANGE_SECOND_EVENT_CANCER = 'criticalIllness/CHANGE_SECOND_EVENT_CANCER',
  CHANGE_CHRONIC_90_DAY = 'criticalIllness/CHANGE_CHRONIC_90_DAY',
  CHANGE_SUPP_CI_HIV = 'criticalIllness/CHANGE_SUPP_CI_HIV',
  CHANGE_SUPP_CI = 'criticalIllness/CHANGE_SUPP_CI',
  CHANGE_CONTINUATION_COVERAGE = 'criticalIllness/CHANGE_CONTINUATION_COVERAGE',
  CHANGE_CHRONIC_365_DAY = 'criticalIllness/CHANGE_CHRONIC_365_DAY',
  CHANGE_RETURN_OF_PREMIUM = 'criticalIllness/CHANGE_RETURN_OF_PREMIUM',
  CHANGE_THREE_TIER = 'criticalIllness/CHANGE_THREE_TIER',
  CHANGE_J_STAMP = 'criticalIllness/CHANGE_J_STAMP',
  CHANGE_PACKAGE_SOURCE = 'criticalIllness/CHANGE_PACKAGE_SOURCE',
  GET_PACKAGE_SOURCE_LIST = 'criticalIllness/GET_PACKAGE_SOURCE_LIST',
  CHANGE_PACKAGE_SOURCE_LIST = 'criticalIllness/CHANGE_PACKAGE_SOURCE_LIST',
  CHANGE_RIDER_CODES = 'criticalIllness/CHANGE_RIDER_CODES',
  CHANGE_RIDER_AMT = 'criticalIllness/CHANGE_RIDER_AMT',
  GET_FILTERED_RIDER_CODES = 'criticalIllness/GET_FILTERED_RIDER_CODES',
  CHANGE_RIDER_CODE2 = 'criticalIllness/CHANGE_RIDER_CODE2',
  GET_CI_PRODUCTS = 'criticalIllness/GET_CI_PRODUCTS',
  CHANGE_CI_PRODUCTS = 'criticalIllness/CHANGE_CI_PRODUCTS',
  GET_CI_PLANTYPES = 'criticalIllness/GET_CI_PLANTYPES',
  CHANGE_CI_PLANTYPES = 'criticalIllness/CHANGE_CI_PLANTYPES',
  GET_CI_SMOKERCODES = 'criticalIllness/GET_CI_SMOKERCODES',
  CHANGE_CI_SMOKERCODES = 'criticalIllness/CHANGE_CI_SMOKERCODES',
  GET_RIDER_INFORMATION = 'criticalIllness/GET_RIDER_INFORMATION',
  CHANGE_CANCER_BENEFIT = 'criticalIllness/CHANGE_CANCER_BENEFIT',
  REMOVE_RIDER = 'criticalIllness/REMOVE_RIDER',
  CHANGE_RIDER_INFORMATION = 'criticalIllness/CHANGE_RIDER_INFORMATION',
  CHANGE_RIDER_INFORMATION_DATA = 'criticalIllness/CHANGE_RIDER_INFORMATION_DATA',
  CLEAR_CRITICAL_ILLNESS = 'criticalIllness/CLEAR_CRITICAL_ILLNESS',
  CHANGE_CICR1_RIDER = 'criticalIllness/CHANGE_CICR1_RIDER',
  CHANGE_SKIN_CANCER_UNIT = 'criticalIllness/CHANGE_SKIN_CANCER_UNIT',
}

export const isCriticalIllnessAction = (action: any): action is CriticalIllnessAction =>
  action.type in reverseEnum(CriticalIllnessActionType);

export const changeProductType = (productType: string) =>
  createAction(CriticalIllnessActionType.CHANGE_PRODUCT_TYPE, {productType});
export const changeSkinCancerUnit = (skinCancerUnit: string) => 
  createAction(CriticalIllnessActionType.CHANGE_SKIN_CANCER_UNIT, {skinCancerUnit});
export const changePlanType = (planType: string) =>
  createAction(CriticalIllnessActionType.CHANGE_PLAN_TYPE, {planType});
export const changeBenefitAmount = (benefitAmount: number) =>
  createAction(CriticalIllnessActionType.CHANGE_BENEFIT_AMOUNT, {benefitAmount});
export const changePremium = (premium: string) => createAction(CriticalIllnessActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(CriticalIllnessActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(CriticalIllnessActionType.CHANGE_CWA, {cwa});
export const changeInsuredSC = (insuredSC: string) =>
  createAction(CriticalIllnessActionType.CHANGE_INSURED_SC, {insuredSC});
export const changeSpouseSC = (spouseSC: string) =>
  createAction(CriticalIllnessActionType.CHANGE_SPOUSE_SC, {spouseSC});
export const changeSection125 = (section125: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SECTION125, {section125});
export const changeReplacement = (replacement: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_REPLACEMENT, {replacement});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(CriticalIllnessActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeSitusState = (situsState: string) =>
  createAction(CriticalIllnessActionType.CHANGE_SITUS_STATE, {situsState});
export const changeCancer = (cancer: boolean) => createAction(CriticalIllnessActionType.CHANGE_CANCER, {cancer});
export const changeSkinCancer = (skinCancer: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SKIN_CANCER, {skinCancer});
export const changeCardiopulmonaryEnhancement = (cardiopulmonaryEnhancement: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_CARDIOPULMONARY_ENHANCEMENT, {cardiopulmonaryEnhancement});
export const changeLifestyleEnhancement = (lifestyleEnhancement: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_LIFESTYLE_ENHANCEMENT, {lifestyleEnhancement});
export const changeSecondEvaluationTransportation = (secondEvaluationTransportation: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SECOND_EVALUATION_TRANSPORTATION, {secondEvaluationTransportation});
export const changeSpecifiedDiseaseEnhancement = (specifiedDiseaseEnhancement: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SPECIFIED_DISEASE_ENHANCEMENT, {specifiedDiseaseEnhancement});
export const changeSpecifiedChronicCI = (specifiedChronicCI: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SPECIFIED_CHRONIC_CI, {specifiedChronicCI});
export const changeSpecifiedChronicCIInjury = (specifiedChronicCIInjury: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SPECIFIED_CHRONIC_CI_INJURY, {specifiedChronicCIInjury});
export const changeRecurrence = (recurrence: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_RECURRENCE, {recurrence});
export const changeCriticalIllnessEnhancement = (criticalIllnessEnhancement: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_CRITICAL_ILLNESS_ENHANCEMENT, {criticalIllnessEnhancement});
export const changeWellnessUnits = (wellnessUnits: string) =>
  createAction(CriticalIllnessActionType.CHANGE_WELLNESS_UNITS, {wellnessUnits});
export const changeFixedWellness = (fixedWellnessUnits: string) =>
  createAction(CriticalIllnessActionType.CHANGE_FIXED_WELLNESS, {fixedWellnessUnits});
export const changeVariableWellness = (variableWellnessUnits: string) =>
  createAction(CriticalIllnessActionType.CHANGE_VARIABLE_WELLNESS, {variableWellnessUnits});
export const changeWellnessPreventiveCare = (wellnessPreventiveCareUnits: string) =>
  createAction(CriticalIllnessActionType.CHANGE_WELLNESS_PREVENTIVE_CARE, {wellnessPreventiveCareUnits});
export const changeCIBenefit = (ciBenefit: string) =>
  createAction(CriticalIllnessActionType.CHANGE_CI_BENEFIT, {ciBenefit});
export const changeCIOptionII = (ciOptionII: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_CI_OPTION_II, {ciOptionII});
export const changeSecondEventCI = (secondEventCI: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SECOND_EVENT_CI, {secondEventCI});
export const changeSecondEventCancer = (secondEventCancer: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SECOND_EVENT_CANCER, {secondEventCancer});
export const changeChronic90Day = (chronic90Day: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_CHRONIC_90_DAY, {chronic90Day});
export const changeSuppCIHIV = (suppCIHIV: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_SUPP_CI_HIV, {suppCIHIV});
export const changeSuppCI = (suppCI: boolean) => createAction(CriticalIllnessActionType.CHANGE_SUPP_CI, {suppCI});
export const changeContinuationCoverage = (continuationCoverage: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_CONTINUATION_COVERAGE, {continuationCoverage});
export const changeChronic365Day = (chronic365Day: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_CHRONIC_365_DAY, {chronic365Day});
export const changeReturnOfPremium = (returnOfPremium: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_RETURN_OF_PREMIUM, {returnOfPremium});
export const changeThreeTier = (threeTier: string) =>
  createAction(CriticalIllnessActionType.CHANGE_THREE_TIER, {threeTier});
export const changeJStamp = (jStamp: boolean) => createAction(CriticalIllnessActionType.CHANGE_J_STAMP, {jStamp});
export const changePackageSource = (packageSource: string) =>
  createAction(CriticalIllnessActionType.CHANGE_PACKAGE_SOURCE, {packageSource});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(CriticalIllnessActionType.CHANGE_RIDER_CODES, {riderCode, index});
export const changeRiderAmt = (riderAmt: number, index: number) =>
  createAction(CriticalIllnessActionType.CHANGE_RIDER_AMT, {riderAmt, index});
export const changeRiderCode2 = (rc2: string) => createAction(CriticalIllnessActionType.CHANGE_RIDER_CODE2, {rc2});
export const getFilteredRiderCodes = (code: number) =>
  createAction(CriticalIllnessActionType.GET_FILTERED_RIDER_CODES, {code});
export const getCIProducts = (friendlyName: string) =>
  createAction(CriticalIllnessActionType.GET_CI_PRODUCTS, {friendlyName});
export const changeCIProducts = (products: Async<Plan[]>) =>
  createAction(CriticalIllnessActionType.CHANGE_CI_PRODUCTS, {products});
export const getCIPlanTypes = (family: string, product: string) =>
  createAction(CriticalIllnessActionType.GET_CI_PLANTYPES, {family, product});
export const changeCIPlanTypes = (planTypes: Async<string[]>) =>
  createAction(CriticalIllnessActionType.CHANGE_CI_PLANTYPES, {planTypes});
export const getCISmokerCodes = () => createAction(CriticalIllnessActionType.GET_CI_SMOKERCODES);
export const changeCISmokerCodes = (smokerCodes: Async<string[]>) =>
  createAction(CriticalIllnessActionType.CHANGE_CI_SMOKERCODES, {smokerCodes});
export const getRiderInformation = (product: string, family: string) =>
  createAction(CriticalIllnessActionType.GET_RIDER_INFORMATION, {product, family});
export const changeRiderInformation = (riderInformation: Async<RiderInformationBase>) =>
  createAction(CriticalIllnessActionType.CHANGE_RIDER_INFORMATION, {riderInformation});
export const getPackageSourceList = (caseNumber: string, planCode: string) =>
  createAction(CriticalIllnessActionType.GET_PACKAGE_SOURCE_LIST, {caseNumber, planCode});
export const changePackageSourceApi = (packageSourceList: Async<object[]>) =>
  createAction(CriticalIllnessActionType.CHANGE_PACKAGE_SOURCE_LIST, {packageSourceList});
export const changeCancerBenefit = (benefit: boolean) =>
  createAction(CriticalIllnessActionType.CHANGE_CANCER_BENEFIT, {benefit});
export const changeRiderInformationData = (amount: number, code: string, index: number) =>
  createAction(CriticalIllnessActionType.CHANGE_RIDER_INFORMATION_DATA, {amount, code, index});
export const removeRider = (index: number) => createAction(CriticalIllnessActionType.REMOVE_RIDER, {index});
export const clearCriticalIllness = () => createAction(CriticalIllnessActionType.CLEAR_CRITICAL_ILLNESS);
export const changeCICR1Rider = (rider: boolean) => createAction(CriticalIllnessActionType.CHANGE_CICR1_RIDER, {rider});

export type CriticalIllnessAction =
  | ReturnType<typeof changeProductType>
  | ReturnType<typeof changePlanType>
  | ReturnType<typeof changeBenefitAmount>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeInsuredSC>
  | ReturnType<typeof changeSpouseSC>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeCICR1Rider>
  | ReturnType<typeof changeCancer>
  | ReturnType<typeof changeSkinCancer>
  | ReturnType<typeof changeSkinCancerUnit>
  | ReturnType<typeof changeCardiopulmonaryEnhancement>
  | ReturnType<typeof changeLifestyleEnhancement>
  | ReturnType<typeof changeSecondEvaluationTransportation>
  | ReturnType<typeof changeSpecifiedDiseaseEnhancement>
  | ReturnType<typeof changeSpecifiedChronicCI>
  | ReturnType<typeof changeSpecifiedChronicCIInjury>
  | ReturnType<typeof changeRecurrence>
  | ReturnType<typeof changeCriticalIllnessEnhancement>
  | ReturnType<typeof changeWellnessUnits>
  | ReturnType<typeof changeFixedWellness>
  | ReturnType<typeof changeVariableWellness>
  | ReturnType<typeof changeWellnessPreventiveCare>
  | ReturnType<typeof changeCIBenefit>
  | ReturnType<typeof changeCIOptionII>
  | ReturnType<typeof changeSecondEventCI>
  | ReturnType<typeof changeSecondEventCancer>
  | ReturnType<typeof changeChronic90Day>
  | ReturnType<typeof changeSuppCIHIV>
  | ReturnType<typeof changeSuppCI>
  | ReturnType<typeof changeChronic365Day>
  | ReturnType<typeof changeContinuationCoverage>
  | ReturnType<typeof changeReturnOfPremium>
  | ReturnType<typeof changeThreeTier>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof changePackageSource>
  | ReturnType<typeof changeRiderCodes>
  | ReturnType<typeof changeRiderAmt>
  | ReturnType<typeof getFilteredRiderCodes>
  | ReturnType<typeof getCIProducts>
  | ReturnType<typeof changeCIProducts>
  | ReturnType<typeof getCIPlanTypes>
  | ReturnType<typeof changeCIPlanTypes>
  | ReturnType<typeof getCISmokerCodes>
  | ReturnType<typeof changeCISmokerCodes>
  | ReturnType<typeof getRiderInformation>
  | ReturnType<typeof changeRiderInformation>
  | ReturnType<typeof getPackageSourceList>
  | ReturnType<typeof changePackageSourceApi>
  | ReturnType<typeof changeCancerBenefit>
  | ReturnType<typeof changeRiderInformation>
  | ReturnType<typeof changeRiderInformationData>
  | ReturnType<typeof removeRider>
  | ReturnType<typeof clearCriticalIllness>;

type CriticalIllnessState = CriticalIllness;

export default (state: CriticalIllnessState, action: CriticalIllnessAction): CriticalIllnessState => {
  switch (action.type) {
    case CriticalIllnessActionType.CHANGE_PRODUCT_TYPE:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeProductType(action.payload.productType),
        Group: G.changeProductType(action.payload.productType),
        NewYork: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SKIN_CANCER_UNIT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSkinCancerUnit(action.payload.skinCancerUnit),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_PLAN_TYPE:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changePlanType(action.payload.planType),
        Group: G.changePlanType(action.payload.planType),
        NewYork: NY.changePlanType(action.payload.planType),
      })(state);
    case CriticalIllnessActionType.CHANGE_BENEFIT_AMOUNT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeBenefitAmount(action.payload.benefitAmount),
        Group: G.changeBenefitAmount(action.payload.benefitAmount),
        NewYork: NY.changeBenefitAmount(action.payload.benefitAmount),
      })(state);
    case CriticalIllnessActionType.CHANGE_PREMIUM:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case CriticalIllnessActionType.CHANGE_CALCULATED_PREMIUM:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case CriticalIllnessActionType.CHANGE_CWA:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case CriticalIllnessActionType.CHANGE_INSURED_SC:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeInsuredSC(action.payload.insuredSC),
        Group: G.changeInsuredSC(action.payload.insuredSC),
        NewYork: NY.changeInsuredSC(action.payload.insuredSC),
      })(state);
    case CriticalIllnessActionType.CHANGE_SPOUSE_SC:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeSpouseSC(action.payload.spouseSC),
        Group: G.changeSpouseSC(action.payload.spouseSC),
        NewYork: NY.changeSpouseSC(action.payload.spouseSC),
      })(state);
    case CriticalIllnessActionType.CHANGE_SECTION125:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeSection125(action.payload.section125),
        Group: G.changeSection125(action.payload.section125),
        NewYork: NY.changeSection125(action.payload.section125),
      })(state);
    case CriticalIllnessActionType.CHANGE_REPLACEMENT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeReplacement(action.payload.replacement),
        Group: G.changeReplacement(action.payload.replacement),
        NewYork: NY.changeReplacement(action.payload.replacement),
      })(state);
    case CriticalIllnessActionType.CHANGE_POLICY_NUMBER:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        Group: G.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        NewYork: NY.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
      })(state);
    case CriticalIllnessActionType.CHANGE_SITUS_STATE:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSitusState(action.payload.situsState),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CICR1_RIDER:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeCICR1Rider(action.payload.rider),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CANCER:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeCancerOption(action.payload.cancer),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SKIN_CANCER:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSkinCancerOption(action.payload.skinCancer),
        _: () => state,
      })(state);

    case CriticalIllnessActionType.CHANGE_CARDIOPULMONARY_ENHANCEMENT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeCardiopulmonaryEnhancementOption(action.payload.cardiopulmonaryEnhancement),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_LIFESTYLE_ENHANCEMENT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeLifestyleEnhancementOption(action.payload.lifestyleEnhancement),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SECOND_EVALUATION_TRANSPORTATION:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSecondEvaluationTransportationOption(action.payload.secondEvaluationTransportation),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SPECIFIED_DISEASE_ENHANCEMENT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSpecifiedDiseaseEnhancementOption(action.payload.specifiedDiseaseEnhancement),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SPECIFIED_CHRONIC_CI:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSpecifiedChronicCIOption(action.payload.specifiedChronicCI),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SPECIFIED_CHRONIC_CI_INJURY:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSpecifiedChronicCIInjuryOption(action.payload.specifiedChronicCIInjury),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_RECURRENCE:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeRecurrenceOption(action.payload.recurrence),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CRITICAL_ILLNESS_ENHANCEMENT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeCriticalIllnessEnhancement(action.payload.criticalIllnessEnhancement),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_WELLNESS_UNITS:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeWellnessUnit(action.payload.wellnessUnits),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_FIXED_WELLNESS:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeFixedWellnessUnit(action.payload.fixedWellnessUnits),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_VARIABLE_WELLNESS:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeVariableWellnessUnit(action.payload.variableWellnessUnits),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_WELLNESS_PREVENTIVE_CARE:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeWellnessPreventiveCareUnit(action.payload.wellnessPreventiveCareUnits),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CI_BENEFIT:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeCIBenefit(action.payload.ciBenefit),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CI_OPTION_II:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeCIOptionII(action.payload.ciOptionII),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SECOND_EVENT_CI:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSecondEventCI(action.payload.secondEventCI),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SECOND_EVENT_CANCER:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSecondEventCancer(action.payload.secondEventCancer),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CHRONIC_90_DAY:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeChronic90Day(action.payload.chronic90Day),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SUPP_CI_HIV:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSuppCIHIV(action.payload.suppCIHIV),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_SUPP_CI:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeSuppCI(action.payload.suppCI),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CONTINUATION_COVERAGE:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeContiuationCoverage(action.payload.continuationCoverage),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CHRONIC_365_DAY:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeChronic365Day(action.payload.chronic365Day),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_RETURN_OF_PREMIUM:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeReturnOfPremium(action.payload.returnOfPremium),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_THREE_TIER:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeThreeTier(action.payload.threeTier),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_J_STAMP:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changeJStamp(action.payload.jStamp),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_PACKAGE_SOURCE:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changePackageSource(action.payload.packageSource),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_RIDER_CODES:
      return matchCriticalIllnessByType<CriticalIllness>({
        NewYork: NY.changeRiderCodes(action.payload.riderCode, action.payload.index),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_RIDER_AMT:
      return matchCriticalIllnessByType<CriticalIllness>({
        NewYork: NY.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.GET_CI_PRODUCTS:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeProductList(new Loading()),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CI_PRODUCTS:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeProductList(action.payload.products),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.GET_CI_PLANTYPES:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changePlanTypes(new Loading()),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CI_PLANTYPES:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changePlanTypes(action.payload.planTypes),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.GET_CI_SMOKERCODES:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeSmokingCodes(new Loading()),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CI_SMOKERCODES:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeSmokingCodes(action.payload.smokerCodes),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.GET_RIDER_INFORMATION:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeRiderInformation(new Loading()),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_RIDER_INFORMATION:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeRiderInformation(action.payload.riderInformation),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.GET_PACKAGE_SOURCE_LIST:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changePackageSourceList(new Loading()),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_PACKAGE_SOURCE_LIST:
      return matchCriticalIllnessByType<CriticalIllness>({
        Group: G.changePackageSourceList(action.payload.packageSourceList),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_CANCER_BENEFIT:
      return matchCriticalIllnessByType<CriticalIllness>({
        NewYork: NY.changeCancerBenefit(action.payload.benefit),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.REMOVE_RIDER:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.removeRider(action.payload.index),
        NewYork: NY.removeRider(action.payload.index),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CHANGE_RIDER_INFORMATION_DATA:
      return matchCriticalIllnessByType<CriticalIllness>({
        Ordinary: O.changeRiderInformationData(action.payload.amount, action.payload.code, action.payload.index),
        _: () => state,
      })(state);
    case CriticalIllnessActionType.CLEAR_CRITICAL_ILLNESS:
      if (state.key === 'InvalidGroupCriticalIllness' || state.key === 'ValidGroupCriticalIllness') {
        return G.EmptyGroupCriticalIllness;
      } else if (state.key === 'InvalidNewYorkCriticalIllness' || state.key === 'ValidNewYorkCriticalIllness') {
        return NY.EmptyNewYorkCriticalIllness;
      } else if (state.key === 'InvalidOrdCriticalIllness' || state.key === 'ValidOrdCriticalIllness') {
        return O.EmptyOrdCriticalIllness;
      }

      return state;

    default:
      return state;
  }
};
